<template>
  <div class="text-center">
    <div class="site-header row">
      <div class="col-4"></div>
      <div class="col-4">
        <img src="../../assets/tassyl9-grey.png" class="top-logo mt-4">
        <div class="tagline text-center">
          <p>Connecting you to your future.</p>
        </div>
      </div>
      <div class="col-4"></div>
    </div>
    <h1 class="forgot-header">Resend Email Confirmation Link</h1>
    <div class="justify-content-center text-center forgotPass">
      <form @submit="sendConfirmationEmail" v-if="!submitted">
        <div class="row justify-content-center">
          <div class="col-sm-4">
            <label for="email"><h3>Email</h3></label>
            <br/>
            <div class="row">
              <i class="fa fa-envelope col-2 icon fa-2x"></i> 
              <input type="email" class="form-control col-10" placeholder="Example@Email.com"  v-model="email" required/>
            </div>
          </div>
        </div>
        <br/>
        <div class="row justify-content-center ">
            <button type="submit" class="btn btn-primary send">Send Confirmation Email</button>
        </div>
      </form>
      <div v-else>
        <h3 class="message"> If an account exists that is associated with the email submitted, an email will be sent to confirm your account. </h3>
      </div>
      <br/>
      <a @click="$router.go(-1)"><button class="btn btn-primary return">Return</button></a>
      <br/>
    </div>
  </div>
</template>

<script>
import axios from '../../auth.js'
export default {
  data(){
    return {
      email: '',
      message: null,
      submitted: false
    }
  },
  methods:{
    sendConfirmationEmail(event){
      event.preventDefault()
      axios.post(
        `${process.env.VUE_APP_ENDPOINT}/resend_confirmation_email/`,
        { email: this.email }
      )
      .catch(e => {
        this.message = e.response.data.error
      })
      this.submitted = true
    }
  }
}
</script>

<style scoped>

label {
  margin-bottom: 0px;
  margin-top: 1em;
}

.icon {
  color: #dcdcdc;
} 

.forgotPass {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3em;
  margin-bottom: 3em;
  background-color: white;
  padding-bottom: 2em;
}

.forgot-header {
  margin-top: 2em;
  margin-bottom: 2em;
}

.message {
  padding-top: 2em;
  padding-bottom: 2em;
}

</style>
